import { render } from "./ImageComponent.vue?vue&type=template&id=35fddd67&ts=true"
import script from "./ImageComponent.vue?vue&type=script&lang=ts"
export * from "./ImageComponent.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\kmccullough\\Source\\Repos\\CPHub\\DoctorQueue.FrontEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__